"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpectedError = exports.QueueError = exports.BackgroundJobError = void 0;
// Phase 123 Plan 02 Task 1 — SEV2 subclasses (background degradation).
//
// SEV2 = something failed but no user is blocked right now; retries/DLQ/slack
// absorb it. Sentry level `error`. No ntfy push (only SEV1 pushes).
//
// BackgroundJobError + QueueError have no default httpStatus — they fire
// inside workers (non-HTTP context) where the filter backstop doesn't run.
// UnexpectedError maps to 500 so the filter can use it as the missing-wrap
// backstop for any non-AppError throw that reaches the HTTP boundary.
const base_1 = require("./base");
/** Worker job failed; retry/DLQ has slack. */
class BackgroundJobError extends base_1.AppError {
    static severity = 'sev2';
}
exports.BackgroundJobError = BackgroundJobError;
/** Pub/Sub publish failure, no user blocking. */
class QueueError extends base_1.AppError {
    static severity = 'sev2';
}
exports.QueueError = QueueError;
/** Default bucket for unclassified throws (runtime backstop — Plan 04 filter wraps any non-AppError into this). */
class UnexpectedError extends base_1.AppError {
    static severity = 'sev2';
    static httpStatus = 500;
}
exports.UnexpectedError = UnexpectedError;
